angular.module('mtic')
.constant('MODULE_THREE', {
  "id": 373,
  "slug": "mtic_gr78_m3",
  "name": "Grade 7&8 Module 3",
  "resource_type": "sub_module",
  "content": {},
  "unlocked_by": [],
  "display": {
    "panel": [
      {
        "sub": [
          {
            "slug": "mtic_g78_m3_game_sub_pt1"
          },
          {
            "slug": "mtic_g78_m3_game_sub_pt2"
          },
          {
            "slug": "mtic_g78_m3_alg_balance"
          },
          {
            "slug": "mtic_g78_m3_class_eq"
          },
          {
            "slug": "mtic_g78_m3_represent_eq"
          }
        ],
        "slug": "Thinking about equality"
      },
      {
        "sub": [
          {
            "slug": "mtic_g78_m3_sub_method"
          },
          {
            "slug": "mtic_g78_m3_bracket_wo"
          },
          {
            "slug": "mtic_g78_m3_bracket_wo_pt2"
          },
          {
            "slug": "mtic_g78_m3_bracket_incl"
          }
        ],
        "slug": "Solving Strategies"
      },
      {
        "sub": [
          {
            "slug": "mtic_g78_m3_geo_perim"
          },
          {
            "slug": "mtic_g78_m3_geo_area"
          },
          {
            "slug": "mtic_g78_m3_word_prob"
          },
          {
            "slug": "mtic_g78_m3_word_prob_pt2"
          }
        ],
        "slug": "Building Equations"
      },
      {
        "sub": [
          {
            "slug": "mtic_g78_m3_impos_eq"
          },
          {
            "slug": "mtic_g78_m3_impos_eq_pt2"
          }
        ],
        "slug": "Special Equations"
      },
      {
        "sub": [
          {
            "slug": "mtic_g78_m3_alice_bob"
          },
          {
            "slug": "mtic_g78_m3_equal_area"
          },
          {
            "slug": "mtic_g78_m3_receipt"
          },
          {
            "slug": "mtic_g78_m3_open"
          },
          {
            "sub": [
              {
                "slug": "mtic_g78_m3_graph_area"
              },
              {
                "slug": "mtic_g78_m3_graph_perim"
              }
            ],
            "slug": "Equations and Graphs"
          }
        ],
        "slug": "Problems"
      }
    ],
    "position": {
      "x": 525,
      "y": -278
    }
  },
  "config": {
    "stats": {
      "lessons": {
        "by": "resource_type",
        "value": "lesson"
      },
      "summative": {
        "by": "slug",
        "value": "mtic_g78_m3_sum"
      },
      "diagnostic": {
        "by": "slug",
        "value": "mtic_g78_m3_diag"
      }
    },
    "meta_locks": {
      "lessons": [
        "diagnostic"
      ],
      "summative": [
        "lessons"
      ],
      "diagnostic": []
    },
    "teacher_panel": {
      "agenda": {},
      "dashboard": {},
      "workspace": {}
    }
  },
  "parent_resource_id": 316,
  "hierarchy_level": 2,
  "children": [
    {
      "id": 374,
      "slug": "mtic_g78_m3_game_sub_pt1",
      "name": "Substitution Game (Part 1)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.15",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_diag"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": 708.4500612147657,
          "y": 375.41040433369943
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 375,
      "slug": "mtic_g78_m3_diag",
      "name": "Diagnostic",
      "resource_type": "assessment",
      "content": {
        "version": "v1.1.6",
        "container": "inbook_package"
      },
      "unlocked_by": [],
      "display": {
        "color": "red",
        "position": {
          "x": 920.0198592255623,
          "y": 233.58129138068642
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 376,
      "slug": "mtic_g78_m3_game_sub_pt2",
      "name": "Substitution Game (Part 2)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.12",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_game_sub_pt1"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": 533.7787245395305,
          "y": 356.55768611411366
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 377,
      "slug": "mtic_g78_m3_graph_perim",
      "name": "variation-périmètre",
      "resource_type": "lesson",
      "content": {
        "version": "v1.1.6",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_diag"
      ],
      "display": {
        "color": "black",
        "position": {
          "x": 1066.3005586929062,
          "y": 420.2221407390573
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    // {
    //   "id": 378,
    //   "slug": "mtic_g78_m3_inver_oper",
    //   "name": "Opérations inverses (Part 1)",
    //   "resource_type": "lesson",
    //   "content": {
    //     "version": "v0.0.15",
    //     "container": "inbook_package"
    //   },
    //   "unlocked_by": [
    //     "mtic_g78_m3_diag"
    //   ],
    //   "display": {
    //     "color": "blue",
    //     "position": {
    //       "x": 785.058362778898,
    //       "y": 3.5658388771014904
    //     }
    //   },
    //   "config": {},
    //   "parent_resource_id": 373,
    //   "hierarchy_level": 3
    // },
    // {
    //   "id": 379,
    //   "slug": "mtic_g78_m3_inver_oper_pt2",
    //   "name": "Opérations inverses (Part 2)",
    //   "resource_type": "lesson",
    //   "content": {
    //     "version": "v1.0.0",
    //     "container": "inbook_package"
    //   },
    //   "unlocked_by": [
    //     "mtic_g78_m3_inver_oper"
    //   ],
    //   "display": {
    //     "color": "blue",
    //     "position": {
    //       "x": 621.6610373864353,
    //       "y": -121.1562963525572
    //     }
    //   },
    //   "config": {},
    //   "parent_resource_id": 373,
    //   "hierarchy_level": 3
    // },
    {
      "id": 380,
      "slug": "mtic_g78_m3_alg_balance",
      "name": "Connection between balances and equations",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.7",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_game_sub_pt2"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": 435.7608878102408,
          "y": 205.74339338871835
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 381,
      "slug": "mtic_g78_m3_graph_area",
      "name": "Potager",
      "resource_type": "lesson",
      "content": {
        "version": "v3.3.3",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_diag"
      ],
      "display": {
        "color": "black",
        "position": {
          "x": 1147.587078906502,
          "y": 168.64800294270066
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 382,
      "slug": "mtic_g78_m3_class_eq",
      "name": "Classification of equations",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.8",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_alg_balance"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": 426.604799569811,
          "y": 6.274119971343426
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 383,
      "slug": "mtic_g78_m3_sub_method",
      "name": "Méthodes de substitution",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.8",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_class_eq"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": 222.3669813624307,
          "y": -11.564624262966074
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 384,
      "slug": "mtic_g78_m3_bracket_wo",
      "name": "Résolution formelle d’équations – parenthèses (Part 1)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.10",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_sub_method"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": 37.58881379376169,
          "y": -23.093673050968814
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 623,
      "slug": "mtic_g78_m3_bracket_wo_pt2",
      "name": "Résolution formelle d’équations – parenthèses (Part 2)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.11",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_bracket_wo"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -148.23941097527614,
          "y": -40.35043079439743
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 624,
      "slug": "mtic_g78_m3_bracket_incl",
      "name": "Résolution formelle d’équations + parenthèses ",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.17",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_bracket_wo_pt2"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -358.2801149111417,
          "y": -34.24239008546451
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 625,
      "slug": "mtic_g78_m3_impos_eq",
      "name": "Equations impossibles ou indéterminées (Part 1)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.12",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_bracket_incl"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -381.4818075323402,
          "y": -241.43029393661118
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 626,
      "slug": "mtic_g78_m3_impos_eq_pt2",
      "name": "Equations impossibles ou indéterminées (Part 2)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.5",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_impos_eq"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -421.0057440890587,
          "y": -409.903101424669
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 627,
      "slug": "mtic_g78_m3_represent_eq",
      "name": "Representations of Equations",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.5",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_word_prob_pt2"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -898.8514738067945,
          "y": 87.27697021659742
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 628,
      "slug": "mtic_g78_m3_geo_perim",
      "name": "Mise en équation -graphique(s), dessins (Part 1)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.9",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_bracket_incl"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -369.74745691313996,
          "y": 176.78347276767371
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 629,
      "slug": "mtic_g78_m3_geo_area",
      "name": "Mise en équation -graphique(s), dessins (Part 2)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.9",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_geo_perim"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -459.6260854253665,
          "y": 353.3330475087569
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 630,
      "slug": "mtic_g78_m3_word_prob",
      "name": "Mise en équation-textuelle (Part 1)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.14",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_bracket_incl"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -562.0419445117852,
          "y": 9.357571109647012
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 631,
      "slug": "mtic_g78_m3_word_prob_pt2",
      "name": "Mise en équation-textuelle (Part 2)",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.7",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_word_prob"
      ],
      "display": {
        "color": "blue",
        "position": {
          "x": -725.2756409741629,
          "y": 123.01299448538013
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 632,
      "slug": "mtic_g78_m3_equal_area",
      "name": "égalité-aire",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.10",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_geo_area"
      ],
      "display": {
        "color": "red",
        "position": {
          "x": -399.77585181276936,
          "y": 520.107814442736
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 633,
      "slug": "mtic_g78_m3_alice_bob",
      "name": "Alice & Bob",
      "resource_type": "lesson",
      "content": {
        "version": "v2.2.7",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_diag"
      ],
      "display": {
        "color": "red",
        "position": {
          "x": 737.9664796007713,
          "y": -261.08689471961003
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 634,
      "slug": "mtic_g78_m3_open",
      "name": "Open Item",
      "resource_type": "lesson",
      "content": {
        "version": "v1.0.10",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_geo_area",
        "mtic_g78_m3_word_prob_pt2"
      ],
      "display": {
        "color": "black",
        "position": {
          "x": -639.7385952385252,
          "y": 292.6916003265879
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    },
    {
      "id": 635,
      "slug": "mtic_g78_m3_receipt",
      "name": "Facture",
      "resource_type": "lesson",
      "content": {
        "version": "v2.0.12",
        "container": "inbook_package"
      },
      "unlocked_by": [
        "mtic_g78_m3_diag"
      ],
      "display": {
        "color": "red",
        "position": {
          "x": 574.2743069853798,
          "y": -290.4157497265492
        }
      },
      "config": {},
      "parent_resource_id": 373,
      "hierarchy_level": 3
    }
  ]
})
